import React from 'react';
import PropTypes from 'prop-types';

const IosArrowLeft = ({ color = '#C70000', width = 7, height = 14 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="14" viewBox="0 0 7 14" fill="none">
    <path d="M6 1.42024L1.40683 6.01341C0.864388 6.55585 0.864388 7.44349 1.40683 7.98594L6 12.5791" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

IosArrowLeft.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default IosArrowLeft; 